import React from "react";
import {Chip} from "@material-ui/core";


export function NotActiveChip() {
  return (
    <Chip
      label="Неактивный"
      size="small"
      style={{
        fontSize: 10,
        textTransform: "uppercase",
        backgroundColor: "#F0A395",
      }}
    />
  );
}
